import { inject, singleton } from "tsyringe";
import { Platform } from "./platform";
import { Device } from "./device";
import { AdsContext } from "./ads-context";

@singleton()
export class Skin {
  constructor(
    @inject(AdsContext) private readonly adsContext: AdsContext,
    @inject(Platform) private readonly platform: Platform,
    @inject(Device) private readonly device: Device,
  ) {}

  private readonly skinMap: Record<string, string> = {
    muthead: "turf",
    futhead: "turf",
    giantbomb: "giantbomb",
    gamefaqs: "gamefaqs",
    gamespot: "gamespot",
    metacritic: "metacritic",
    "metacritic-neutron": "metacritic_neutron",
    comicvine: "comicvine",
    f2: "fandom",
    tvguide: "tvguide",
    fandomdesktop: "ucp",
    fandommobile: "ucp",
    fanatical: "fanatical",
  };

  get(): string {
    const platform = this.platform.get();
    const device =
      this.device.getDeviceType() === "desktop" ? "desktop" : "mobile";

    if (!this.adsContext.get()?.skin) {
      return this.skinMap[platform]
        ? this.skinMap[platform] + "_" + device
        : "unknown";
    }

    const skin = this.adsContext.get().skin ?? platform;
    return `${skin}_${device}`;
  }
}
